// src/components/admin/Login.jsx
import React, { useState } from 'react';
import { signInWithEmailAndPassword } from 'firebase/auth';
import { auth } from '../../firebase';
import { useNavigate } from 'react-router-dom';
import Notification from '../Notification'; // Importe o componente Notification

const Login = () => {
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const [notification, setNotification] = useState(null); // Estado para controlar a notificação
  const navigate = useNavigate();

  const handleSubmit = async (e) => {
    e.preventDefault();
    try {
      await signInWithEmailAndPassword(auth, email, password);
      setNotification({
        message: 'Login realizado com sucesso!',
        type: 'success',
      });
      setTimeout(() => {
        navigate('/admin/dashboard'); // Redireciona após 2 segundos
      }, 2000);
    } catch (error) {
      setNotification({
        message: 'Erro ao fazer login ',
        type: 'error',
      });
    }
  };

  return (
    <>
      <form onSubmit={handleSubmit} className="login-form">
        <h2>Login Admin</h2>
        <div className="form-group">
          <label htmlFor="email">Email</label>
          <input
            type="email"
            id="email"
            placeholder="Digite seu email"
            value={email}
            onChange={(e) => setEmail(e.target.value)}
            required
          />
        </div>
        <div className="form-group">
          <label htmlFor="password">Senha</label>
          <input
            type="password"
            id="password"
            placeholder="Digite sua senha"
            value={password}
            onChange={(e) => setPassword(e.target.value)}
            required
          />
        </div>
        <button type="submit" className="submit-button">
          Entrar
        </button>
      </form>

      {/* Exibe a notificação se existir */}
      {notification && (
        <Notification
          message={notification.message}
          type={notification.type}
          onClose={() => setNotification(null)} // Fecha a notificação
        />
      )}
    </>
  );
};

export default Login;